import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getChartFormByType } from '@/reducers/dashboardChartsReducer';
import { BUILT_IN_CHART_TYPES } from '@/experiment-management-shared/constants';

const useInitialChartState = (chartType: string) => {
  const [initialChartState, setInitialChartState] = useState(null);

  const chartForm = useSelector(state =>
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    /* @ts-ignore */
    getChartFormByType(state, { chartType })
  );

  useEffect(() => {
    const isPythonCode = [
      BUILT_IN_CHART_TYPES.python,
      BUILT_IN_CHART_TYPES.libraryPanel
    ].includes(chartType);

    if (!initialChartState) {
      if (isPythonCode && chartForm?.code === null) return;
      setInitialChartState(chartForm);
    }
  }, [chartForm, chartType, initialChartState]);

  const resetInitialChartState = () => {
    setInitialChartState(null);
  };

  return { initialChartState, resetInitialChartState };
};

export default useInitialChartState;
